import { fileApi } from "~/api";

export const getTasksQueryKey = () => fileApi.queryOptions("get", "/api/Task").queryKey;

export const TASK_TOAST_MESSAGES = {
  CREATE_SUCCESS: "Task created successfully.",
  CREATE_ERROR: "Failed to create task.",
  UPDATE_SUCCESS: "Task updated successfully.",
  UPDATE_ERROR: "Failed to update task.",
  DELETE_WARNING: "Delete task feature is not yet available.",
  STATUS_UPDATE_SUCCESS: "Task status updated successfully.",
  STATUS_COMPLETE_SUCCESS: "Task deactivated and completed successfully.",
  STATUS_UPDATE_ERROR: "Failed to update task status.",
} as const;
